import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      <p className="mt-4 text-gray-600 font-medium">{message}</p>
    </div>
  );
};

const ErrorMessage = ({ message, onRetry = null, isOffline = false }) => {
  const isOfflineError = isOffline || message.toLowerCase().includes('offline');
  
  return (
    <div className={`${isOfflineError ? 'bg-yellow-50 border-yellow-200' : 'bg-red-50 border-red-200'} border rounded-xl p-8 text-center shadow-sm`}>
      <div className={`${isOfflineError ? 'text-yellow-600' : 'text-red-600'} mb-6`}>
        {isOfflineError ? (
          <svg className="h-12 w-12 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.111 16.404a5.5 5.5 0 117.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-12.728 12.728" />
          </svg>
        ) : (
          <svg className="h-12 w-12 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        )}
        <h3 className="text-lg font-semibold">
          {isOfflineError ? 'Working Offline' : 'Something went wrong'}
        </h3>
      </div>
      <p className={`${isOfflineError ? 'text-yellow-700' : 'text-red-700'} mb-6 font-medium`}>
        {message}
      </p>
      {onRetry && !isOfflineError && (
        <button
          onClick={onRetry}
          className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors font-medium shadow-sm"
        >
          Try Again
        </button>
      )}
      {isOfflineError && (
        <div className="text-sm text-yellow-600">
          Your changes are being saved locally and will sync when you're back online.
        </div>
      )}
    </div>
  );
};

const EmptyState = ({ 
  title = 'No bookmarks yet', 
  description = 'Add your first bookmark to get started!',
  action = null 
}) => {
  return (
    <div className="text-center py-16">
      <div className="text-accent mb-6">
        <svg className="h-20 w-20 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-3">{title}</h3>
      <p className="text-gray-500 mb-8 max-w-md mx-auto leading-relaxed">{description}</p>
      {action}
    </div>
  );
};

export { LoadingSpinner, ErrorMessage, EmptyState };
